export default __webpack_public_path__ + "static/media/typescript_logo.29073194.png";